<!-- TÍTULO -->
<div class="container-fluid mt-1">
  <div class="row">
    <div class="col-6 mx-auto text-center text-white">
      <app-alert [titulo]="'Importación de archivos de datos'"></app-alert>
    </div>
  </div>
</div>

<!-- FORMULARIO CENTRADO -->
<div class="d-flex justify-content-center mt-4 px-2">
  <div class="card shadow-lg rounded-4 p-4 w-100" style="max-width: 800px; background-color: #ffffff;">
    
    <!-- Selectores -->
    <div class="mb-3">
      <mat-form-field appearance="outline" class="w-100 mb-3">
        <mat-label>Módulo</mat-label>
        <mat-select [(ngModel)]="selectedModuloId" (selectionChange)="onModuloChange()">
          <mat-option *ngFor="let modulo of modulos" [value]="modulo.idModulo">
            {{ modulo.nombreModulo }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="mb-3">
      <mat-form-field appearance="outline" class="w-100 mb-3">
        <mat-label>Proceso</mat-label>
        <mat-select [(ngModel)]="selectedProcesoId" (selectionChange)="onProcesoChange()">
          <mat-option *ngFor="let proceso of procesosFiltrados" [value]="proceso.idProceso">
            {{ proceso.nombreProceso }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <!-- Descripción dinámica -->
    <div class="mb-3">
      <label class="form-label fw-bold">Descripción del proceso</label>
      <textarea class="form-control" rows="3" readonly>{{ descripcionProceso }}</textarea>
    </div>

    <!-- Botón: Descargar template -->
    <div class="row mb-3">
      <div class="col-12 text-end">
        <div class="d-flex justify-content-end mt-3">
          <button class="btn btn-outline-primary" (click)="descargarTemplate()">
            Descargar template
          </button>
        </div>
      </div>
    </div>

    <!-- Carga de archivo -->
    <div class="mb-3">
      <label class="form-label fw-bold">Seleccionar archivo Excel para importar</label>
      <input type="file" class="form-control" (change)="onFileSelected($event)" accept=".xlsx" />
    </div>

    <!-- Botón: Procesar -->
    <div class="row mb-3">
      <div class="col-12 text-end">
        <div class="d-flex justify-content-end mt-3">
          <button class="btn btn-success" (click)="procesarArchivo()" [disabled]="!archivoSeleccionado">
            Procesar
          </button>
        </div>
      </div>
    </div>

    <!-- Mensaje de error -->
    <div *ngIf="mensajeError" class="alert alert-danger mt-2">
      {{ mensajeError }}
    </div>
  </div>
</div>
